// extracted by mini-css-extract-plugin
export default {"viewer":"Viewer_viewer__IwLdI","ani":"Viewer_ani__bqmAx"};